var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThemeDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 116,
    viewBox: "0 0 183 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_877_1846)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_877_1846",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 183,
    height: 116
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M183 0.71582H0V115.284H183V0.71582Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_877_1846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183 0.71582H0V115.284H183V0.71582Z",
    fill: "#232627"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.875 40.8151C22.875 31.324 30.5561 23.6299 40.0312 23.6299H183V115.284H22.875V40.8151Z",
    fill: "#343839"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0312 45.1111C42.4 45.1111 44.3203 43.1876 44.3203 40.8149C44.3203 38.4421 42.4 36.5186 40.0312 36.5186C37.6625 36.5186 35.7422 38.4421 35.7422 40.8149C35.7422 43.1876 37.6625 45.1111 40.0312 45.1111Z",
    stroke: "#6C7275",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1875 45.1111C59.5563 45.1111 61.4766 43.1876 61.4766 40.8149C61.4766 38.4421 59.5563 36.5186 57.1875 36.5186C54.8187 36.5186 52.8984 38.4421 52.8984 40.8149C52.8984 43.1876 54.8187 45.1111 57.1875 45.1111Z",
    stroke: "#6C7275",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3438 45.1111C76.7125 45.1111 78.6328 43.1876 78.6328 40.8149C78.6328 38.4421 76.7125 36.5186 74.3438 36.5186C71.975 36.5186 70.0547 38.4421 70.0547 40.8149C70.0547 43.1876 71.975 45.1111 74.3438 45.1111Z",
    stroke: "#6C7275",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_877_1846"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 183,
    height: 116,
    rx: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemeDark);
export default __webpack_public_path__ + "static/media/theme-dark.29ecd2e68e29fb5d417536fc73bfe1fe.svg";
export { ForwardRef as ReactComponent };